import $http from "../../helpers/api";

// initial state
const state = {
  all: [],
  asf: []
};

// getters
const getters = {
  getAsf() {
    return state.asf;
  },
  getAll() {
    return state.all;
  }
};

// actions
const actions = {
  getAllAsfs({ commit }) {
    return new Promise((resolve, reject) => {
      $http.get("/asfs?includes[]=phones").then(resp => {
        let arr = [];
        resp.data.asfs.forEach(function(item, i) {
          arr[i] = {
            id: item.id,
            name: item.name,
            vat: item.vat,
            phones: item.phones.map(o => o["phone"]).join(", ")
          };
        });
        commit("setAsfs", arr);
      });
      resolve();
    });
  },
  getAsf({ commit }, asfId) {
    return new Promise(resolve => {
      $http
        .get("/asfs/" + asfId + "?includes[]=addresses&includes[]=phones")
        .then(resp => {
          let arr = {
            id: resp.data.asf.id,
            name: resp.data.asf.name,
            vat: resp.data.asf.vat,
            addresses: resp.data.asf.addresses,
            phones: resp.data.asf.phones
          };
          commit("setAsf", arr);
          resolve();
        });
    });
  },
  getByCode({ commit }, asfCode) {
    return new Promise(resolve => {
      $http
        .get("/asfs/" + asfCode + "/code")
        .then(resp => {
          commit("setAsf", resp.data);
          resolve(resp.data);
        });
    });
  },
  addAsf(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/asfs", { asf: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editAsfs({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .put("/asfs/" + data.id, { asf: data })
        .then(resp => {
          commit("clearAsf");
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchAsfs(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get("/asfs", { params: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteAsf({}, data) {
    return new Promise((resolve, reject) => {
      $http
        .delete("/asfs/" + data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  setAsfs(state, asfs) {
    state.all = asfs;
  },
  setAsf(state, asf) {
    state.asf = asf;
  },
  clearAsf(state) {
    state.asf = [];
  },
  clearAll(state) {
    state.all = [];
    state.asf = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
